import { serverHost } from "../utils/ServerHost";

export async function getInitials(email) {
    const initials = await fetch(serverHost + '/user/initials/' + email, {credentials: 'include'})
    .then(res => res.text()).then(text => text);

    return initials;
}